import React, { createContext, ReactNode, useContext } from "react";
import { AppContextType, useAppContext } from "./appContext";
import DashboardWrapper from "../pages/dashboard/dashboardWrapper";
import { LoginResponseDTO, LoginResponseDTOCategoryEnum } from "../openapi-generated-client";

interface DashboardContextType {
    sessionId: string;
    isAdmin: boolean;
    userData: LoginResponseDTO;
    appContext: AppContextType;
}

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

interface DashboardProviderProps {
    children: ReactNode;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({ children }) => {

    const appContext = useAppContext();

    if(appContext.userData === undefined || appContext.userData.sessionId === undefined || !appContext.isLoggedIn) {
        window.location.href = "/error/0";
        return <></>;
    }

    const value: DashboardContextType = {
        sessionId: appContext.userData.sessionId,
        isAdmin: appContext.userData.category === LoginResponseDTOCategoryEnum.Admin,
        userData: appContext.userData,
        appContext: appContext
    };

    return (
        <DashboardContext.Provider value={value}>
            <DashboardWrapper>
                {children}
            </DashboardWrapper>
        </DashboardContext.Provider>
    );

}


export const useDashboardContext = () => {
    const context = useContext(DashboardContext);
    if (context === undefined) {
        throw new Error('useDashboardContext must be used within a DashboardProvider');
    }
    return context;
};